// import device from './device.js';
// import socket from './socket.js';
import http from './http.js';

const request = { http };

const defaultType = 'http';

const get = ({ type, url, headers, query }) => {
  type = type || defaultType;
  return request[type].get({ url, headers, query });
};

const post = ({ type, url, headers, query, body }) => {
  type = type || defaultType;
  return request[type].post({ url, headers, query, body });
};

const put = ({ type, url, headers, query, body }) => {
  type = type || defaultType;
  return request[type].put({ url, headers, query, body });
};

const destroy = ({ type, url, headers, query, body }) => {
  type = type || defaultType;
  return request[type].destroy({ url, headers, query, body });
};

const jsonp = http.jsonp;
export { http, get, post, put, destroy, jsonp };
export default { http, get, post, put, destroy, jsonp };
